import {getCurrentUserLogin} from '@github-ui/client-env'
import {useReviewers} from '../../data/use-reviewers'

export function isViewerReviewer(
  reviewers: NonNullable<ReturnType<typeof useReviewers>['data']>,
  viewerLogin: string,
): boolean {
  const isViewer = (login: string | undefined) => login === viewerLogin

  return (
    (reviewers.pendingReviewRequests ?? []).some(
      request => request.reviewer?.reviewerType === 'User' && isViewer(request.reviewer.displayLogin),
    ) ||
    (reviewers.completedReviews ?? []).some(
      review => review.reviewer?.reviewerType === 'User' && isViewer(review.reviewer.displayLogin),
    )
  )
}

/**
 * Whether the current viewer is a "reviewer" of the pull request — i.e., they have
 * either an outstanding (pending) review request or a completed review, in any state
 * (approved, commented, changes requested, or dismissed).
 *
 * Only considers the viewer's own user-level participation; team review requests are
 * not treated as making the viewer an individual reviewer.
 */
export function useViewerIsReviewer(): boolean | null {
  const viewerLogin = getCurrentUserLogin()
  const {data: reviewers} = useReviewers()

  if (!viewerLogin) return false
  if (!reviewers) return null

  return isViewerReviewer(reviewers, viewerLogin)
}
